import { QueryOptions } from "src/app/helpers/QueryOptions";

export class AsyncPaginatorData {
	page : number;
	amount : number;

	constructor(page:number, amount:number) {
		this.page = page;
		this.amount = amount;
	}

	toQueryOptions(qo?:QueryOptions) : QueryOptions {
		if (!qo) {
			let qo = new QueryOptions();
			qo.page = this.page;
			qo.limit = this.amount;
			return qo;
		} else {
			qo.page = this.page;
			qo.limit = this.amount;
			return qo;
		}
	}
}